module.exports = __webpack_public_path__ + "static/media/Exersează-ți memoria.955cab48.png";